import { Edit, Form, Toolbar } from 'react-admin';
import { matchPath, useLocation } from 'react-router-dom';
import { Box, CardContent } from '@mui/material';
import { GoToListButton } from '../../../components/GoToListButton';
import { OBJECTS_TYPES } from '../../../constants';
import { ApartmentAside } from '../ApartmentAside';
import { ApartmentInputs } from '../ApartmentInputs';

export const ApartmentEdit = () => {
	const { pathname } = useLocation();
	const match = matchPath(
		{ path: `objects/${OBJECTS_TYPES.APARTMENTS}/edit/:id` },
		pathname
	);

	if (!match) {
		return null;
	}

	const { params } = match;

	return (
		<Box mt={3}>
			<GoToListButton />
			<Box mt={4}>
				<Edit
					aside={<ApartmentAside link="show" />}
					actions={false}
					resource={OBJECTS_TYPES.PROPERTIES}
					redirect={`/objects/${OBJECTS_TYPES.APARTMENTS}/show/${params.id}`}
					transform={values => {
						// add https:// before website if not present
						if (values.website && !values.website.startsWith('http')) {
							values.website = `https://${values.website}`;
						}
						return values;
					}}
				>
					<Form>
						<CardContent sx={{ padding: 0 }}>
							<ApartmentInputs />
						</CardContent>
						<Toolbar />
					</Form>
				</Edit>
			</Box>
		</Box>
	);
};
